import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { inventoryState, StatusFilter } from "../types/index";
import { initialState } from "./initialState";

export const sliceKey = "inventoryState";

export const inventorySlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
    setStatusFilter: (state, action: PayloadAction<StatusFilter>) => {
      state.statusFilter = action.payload;
    }}})

export const { reducer, actions } = inventorySlice